import { ensureNamespace } from '@/lib/i18n/runtime';
import { createFileRoute } from '@tanstack/react-router';
import { CommentsPage } from '@/features/tiktok/components/CommentsPage';
export const Route = createFileRoute('/_auth/comments')({ beforeLoad: async () => { await Promise.all([ensureNamespace('shell'), ensureNamespace('tiktok')]).catch(() => { /* Boundary provides retry. */ }); }, component: CommentsPage });
